module.exports = __webpack_public_path__ + "assets/img/page1-design-side-nav-expanded-3-ea2cda42.png";